import type { FutureConfig } from 'react-router-dom';

export const routerFutureConfig = {
  v7_relativeSplatPath: true,
  v7_startTransition: true,
} satisfies Partial<FutureConfig>;
